(function () {
  var box0 = document.querySelector('[data-bl-ship]');
  if (!box0) return;

  var BRAND = box0.getAttribute('data-bl-ship-brand') || 'wsb';
  var TAILORED = box0.getAttribute('data-bl-ship-tailored') === 'true';
  var MARKET = box0.getAttribute('data-bl-ship-market') || 'ca';

  var WSB_QS = ["15199PC","15199PN","15199SB","15214PN","15356PC","15356PN","15356SB","15586PC","15586PN","15586SB","15609PC","15609PN","15609SB","15610PC","15610PN","15610SB","15620PC","15620PN","15620SB","15623PC","15623PN","15623SB","4343PCU","4399PN","4407PN","4415SPN","7365PN","7367PN","7372PC","7372PN","7372SB","7373PC","7373PN","7373SB","7374PC","7374PN","7374SB","7375PC","7375PN","7375SB","7376PC","7376PN","7376SB","7377PC","7377PN","7377SB","7380PC","7380PN","7380SN","7381PC","7381PN","7381SN","7382PC","7382PN","7382SN","7383PN","7383SN","7384PC","7384PN","7385PN","7386PC","7386PN","7388PN","7388SN","7393PC","7393PN","7393SB","7480PN","7481PN","7482PN","7501PN","7501SB","7502PN","7502SB","7503PN","7503SB","7504PN","7504SB","7505PN","7505SB","7515PN","7515SB","7516PN","7615PC","7615PN","7615SB","7618PC","7618PN","7620PC","7620PN","7620SB","7621PC","7621PN","7621SB","7771PN","7772PN","7773PN","7774PN","7775PN","7776PN","7791PC","7791PN","7791SB","7792PC","7792PN","7792SB","7793PC","7793PN","7793SB","7794PC","7794PN","7794SB","7795PC","7795PN","7795SB","7796PN","7815PN","7816PN","7860PN","7861PN","7862PN","7863PN","7864PN","7870PN","7871PN","7872PN","8369PN","8432PN","8433PN","8435PN","8442PN","8446PN","8447PN","8448PC","8448PN","8448SB","8449PC","8449PN","8449SB","8505BPN","8505CPN","8505PC","8505PN","8505SB","8506PC","8506PN","8527PC","8527PN","8527SB","8530PN","8531PC","8531PN","8531SN","8532PN","8533PN","8534PN","8560CPC","8560CPN","8560CSB","8560DPC","8560DPN","8560DSB","8560PC","8560PN","8560SB","8561CPC","8561CPN","8561CSB","8561DPC","8561DPN","8561DSB","8561PC","8561PN","8561SB","8562CPC","8562CPN","8562CSB","8562DPC","8562DPN","8562DSB","8562PN","8562SB","8581PN","8581SB","8582PN","8582SB","8620PN","8620SB","8621PN","8621SB","8622PN","8622SB","8631PN","8631SB","8641PN","8643PN"];

  // ARMAC_QS — Armac ready-to-ship SKUs (our variant SKUs = Armac codes).
  // Empty for now: every Armac variant reads the standard line until filled.
  var ARMAC_QS = [];

  // KARTNERS_QS — optional in-stock SKU set. Empty for now.
  var KARTNERS_QS = [];

  // EMTEK_QS / SCHAUB_QS — Emtek and Schaub share one SoCal warehouse. Empty
  // for now. Emtek ExpressShip can populate EMTEK_QS later; US3NL is excluded
  // from ExpressShip and carries a longer lead if split out per finish_code.
  var EMTEK_QS = [];
  var SCHAUB_QS = [];

  // COLONIAL_QS — hand finished to order, no stocking program. Staged empty.
  var COLONIAL_QS = [];

  // STOCK_QS — Top Knobs, Atlas, Jeffrey Alexander ship next day from stock.
  // The standard line already says next business day, so QS is not used.
  var STOCK_QS = [];

  var COPY_CA = {
    wsb:      { qEyebrow:"Quick Ship", qText:"In stock. Ships in approximately 2 weeks.", sEyebrow:"Lead Time", sText:"Approximately 10 weeks, finished to order." },
    armac:    { qEyebrow:"Quick Ship", qText:"In stock and ready to ship, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Made to order by Armac Martin. Approximately 2 to 4 weeks to our Calgary showroom." },
    kartners: { qEyebrow:"Quick Ship", qText:"In stock and ready to ship, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Each piece is brought in specifically for your project. Approximately 2 weeks to our Calgary showroom." },
    emtek:    { qEyebrow:"Quick Ship", qText:"In stock for ExpressShip, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Assembled to order by Emtek. Approximately 2 weeks to our Calgary showroom." },
    schaub:   { qEyebrow:"Quick Ship", qText:"In stock and ready to ship, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Assembled to order by Schaub. Approximately 2 weeks to our Calgary showroom." },
    colonial: { qEyebrow:"Quick Ship", qText:"In stock and ready to ship, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Hand finished to order by Colonial Bronze in Torrington, Connecticut. Approximately 4 weeks plus transit to our Calgary showroom." },
    stock:    { qEyebrow:"Quick Ship", qText:"In stock. Ships the next business day.", sEyebrow:"Lead Time", sText:"In stock. Ships the next business day." }
  };

  var COPY_US = {
    wsb:      { qEyebrow:"Quick Ship", qText:"In stock. Ships within 2 business days.", sEyebrow:"Lead Time", sText:"Approximately 10 weeks, finished to order, then ships." },
    armac:    { qEyebrow:"Quick Ship", qText:"In stock and ready to ship.", sEyebrow:"Lead Time", sText:"Made to order by Armac Martin." },
    kartners: { qEyebrow:"Quick Ship", qText:"In stock and ready to ship.", sEyebrow:"Lead Time", sText:"Each piece is brought in specifically for your project." },
    emtek:    { qEyebrow:"Quick Ship", qText:"In stock for ExpressShip, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Assembled to order by Emtek. Approximately 6 business days, then ships." },
    schaub:   { qEyebrow:"Quick Ship", qText:"In stock and ready to ship, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Assembled to order by Schaub. Approximately 6 business days, then ships." },
    colonial: { qEyebrow:"Quick Ship", qText:"In stock and ready to ship, ahead of standard lead times.", sEyebrow:"Lead Time", sText:"Hand finished to order by Colonial Bronze in Torrington, Connecticut. Approximately 4 weeks, then ships." },
    stock:    { qEyebrow:"Quick Ship", qText:"In stock. Ships the next business day.", sEyebrow:"Lead Time", sText:"In stock. Ships the next business day." }
  };

  var SET = (MARKET === 'us') ? COPY_US : COPY_CA;

  // Colonial Bronze tailored products publish no fixed lead time. Overwrite the
  // standard line so no variant selection can repaint a 4 week promise onto them.
  if (BRAND === 'colonial' && TAILORED) {
    SET.colonial.sText = "Tailored per application. Hand finished to order by Colonial Bronze in Torrington, Connecticut. Lead time is confirmed at quotation.";
  }

  var QS_LIST =
    (BRAND === 'armac')    ? ARMAC_QS :
    (BRAND === 'kartners') ? KARTNERS_QS :
    (BRAND === 'emtek')    ? EMTEK_QS :
    (BRAND === 'schaub')   ? SCHAUB_QS :
    (BRAND === 'colonial') ? COLONIAL_QS :
    (BRAND === 'stock')    ? STOCK_QS :
    WSB_QS;

  var c = SET[BRAND] || SET.wsb;

  var QS = Object.create(null);
  for (var i = 0; i < QS_LIST.length; i++) { QS[QS_LIST[i]] = true; }

  function box() { return document.querySelector('[data-bl-ship]'); }

  function paint(sku) {
    var b = box(); if (!b) return;
    var eb = b.querySelector('[data-bl-ship-eyebrow]');
    var tx = b.querySelector('[data-bl-ship-text]');
    var quick = !!(sku && QS[sku]);
    b.classList.toggle('bl-ship--quick', quick);
    if (eb) eb.textContent = quick ? c.qEyebrow : c.sEyebrow;
    if (tx) tx.textContent = quick ? c.qText : c.sText;
  }

  document.addEventListener('bl:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    paint(v ? v.sku : null);
  });

  function seed() {
    if (window.BLVariantResolver && window.BLVariantResolver.match) {
      var v = window.BLVariantResolver.match();
      if (v) { paint(v.sku); return; }
    }
    var skuEl = document.querySelector('[data-sku]');
    if (skuEl) { paint((skuEl.textContent || '').trim()); }
  }

  document.addEventListener('bl:resolver:ready', seed);
  if (document.readyState !== 'loading') { seed(); } else { document.addEventListener('DOMContentLoaded', seed); }
})();